import styled from 'styled-components';

export default styled.label`
  display: inline-block;
  position: relative;
  cursor: pointer;
  height: 1rem;
  width: 1rem;
  margin-right: .25rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: bottom;
`;
